import { Config } from "../../Config";
import { FaceTecSDK } from "../../../core-sdk/FaceTecSDK.js/FaceTecSDK";
import { NetworkingRequest } from "../utilities/NetworkingRequest";
var FaceTecSDKProcessor = /** @class */ (function () {
    function FaceTecSDKProcessor(callbacks) {
        this.onSessionRequest = function (sessionRequestBlob, sessionRequestCallback) {
            NetworkingRequest.send(sessionRequestBlob, sessionRequestCallback, null);
        };
        this.onFaceTecExit = function (_result) {
            // Initialization: the app handles the result via callbacks.
        };
        this.initializeCallbacks = callbacks;
    }
    FaceTecSDKProcessor.prototype.initialize = function () {
        FaceTecSDK.initializeWithSessionRequest(Config.DeviceKeyIdentifier, this, this.initializeCallbacks);
    };
    return FaceTecSDKProcessor;
}());
export { FaceTecSDKProcessor };
